import React from "react";
import { SolarCitadelLogo } from "./Logo";
import { useT } from "@/i18n/LanguageContext";

const Footer = () => {
  const { t } = useT();
  return (
    <footer data-testid="site-footer" className="relative border-t border-[#D4AF37]/25 bg-[#020C1B]">
      <div className="h-[2px] bg-[#7A1C1C]" />
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div className="flex items-center gap-4">
            <SolarCitadelLogo size={44} />
            <div className="leading-tight">
              <div className="font-serif text-bone tracked-lg text-base" style={{ fontWeight: 600 }}>VIVASVAN</div>
              <div className="font-sans text-[10px] text-steel tracked" style={{ letterSpacing: "0.28em" }}>
                ENERGIES VENTURES (PTY) LTD
              </div>
            </div>
          </div>

          <div className="font-sans text-[12px] text-steel tracked uppercase" style={{ letterSpacing: "0.22em" }} data-testid="footer-copy">
            {t.footer.copyright}
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-[#D4AF37]/12 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-sans text-[11px] text-steel/70 max-w-xl leading-relaxed">
            {t.footer.tagline}
          </div>
          <a
            href="/admin"
            data-testid="admin-link"
            className="font-sans text-[10px] uppercase tracked text-[#D4AF37] hover:text-bone transition-colors"
            style={{ letterSpacing: "0.28em" }}
          >
            {t.footer.admin_link}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
